import { render, staticRenderFns } from "./esqueceu-senha.vue?vue&type=template&id=a4c62bd2"
import script from "./esqueceu-senha.vue?vue&type=script&lang=js"
export * from "./esqueceu-senha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports